module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Montanaire_(Vaud)-2421c5a935d07c0d93adb99e64cfd893.svg";